<template>
    <div class="checkbox" :style="{ '--size': `${size}px` }">
        <input name="checkbox" :id="id" type="checkbox" class="checkbox__input" :checked="checked" @change="onChange"
            :disabled="disabled" />
        <label class="checkbox__label" :for="id">
            <slot name="label"></slot>
        </label>
    </div>
</template>

<script>
export default {
    name: 'checkboxUI',
    props: {
        id: {
            type: String,
            default: () => {
                return `checkbox-${Math.random().toString(36).substring(2, 15)}`;
            }
        },
        checked: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: Number,
            default: 18
        }
    },
    methods: {
        onChange(event) {
            this.$emit('change', event.target.checked);
        }
    }
}
</script>

<style scoped>
.checkbox {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
}

.checkbox__input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: grid;
    flex-shrink: 0;
    place-content: center;
    width: var(--size, 18px);
    height: var(--size, 18px);
    margin: 0;
    margin-top: 3px;
    background-color: var(--background-white);
    border: 1px solid var(--color-primary);
    border-radius: var(--radius-sm);
    transform: translateY(-0.075em) scale(0.8);
    cursor: pointer;
    overflow: hidden;
}

.checkbox__input::before {
    content: "";
    width: 10px;
    height: 10px;
    z-index: 2;
    transform: scale(0);
    box-shadow: inset 1em 1em var(--color-gray);
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
}

.checkbox__input:checked::before {
    transform: scale(1);
}

.checkbox__input::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    transform: scale(0);
    background-color: var(--color-primary);
}

.checkbox__input:checked::after {
    transform: scale(1);
}

.checkbox__label {
    font-family: var(--font-family-primary);
    font-size: var(--text-sm);
    font-weight: 600;
    color: var(--color-secondary);
    cursor: pointer;
    user-select: none;
}
</style>